import { css } from "@emotion/react";
import parse from "html-react-parser";
import { useConfig } from "../../../hooks/useConfig";
import defaultContent from "../../../utils/loginPageAdminDefault";
import type { DOMNode } from "html-react-parser";
import { Element } from "domhandler";

const SAFE_HREF_RE = /^(https:|mailto:|\/|#)/i;

const sanitizeLinkHrefs = (node: DOMNode) => {
  if (node instanceof Element && node.name === "a") {
    const href = node.attribs.href ?? "";
    if (!SAFE_HREF_RE.test(href)) {
      node.attribs.href = "#";
    }
  }
};

export const MarketingText = ({ className }: { className?: string }) => {
  const { loginPageContent } = useConfig();

  return (
    <div
      className={className}
      css={({ colours }) => css`
        flex-grow: 1;
        color: ${colours.primary.mid.dark20};

        h1,
        h2,
        h3 {
          font-family: ScotchDisplay-Roman;
          font-weight: normal;
          font-style: normal;
          line-height: normal;
          letter-spacing: normal;
        }
        h1 {
          font-size: 36px;
        }
        h2 {
          font-size: 30px;
        }
        h3 {
          font-size: 24px;
        }
        p {
          font-size: 15px;
          line-height: 1.6;
          margin: 0.5em 0;
        }
        ul,
        ol {
          padding-left: 1.5em;
          font-size: 15px;
          line-height: 1.8;
        }
        ul {
          list-style-type: disc;
        }
        ol {
          list-style-type: decimal;
        }
        a {
          color: ${colours.primary.mid.dark20};
          display: inline-flex;
          align-items: center;
          gap: 8px;
        }
      `}
    >
      {parse(
        // if you delete the default content in the admin you get <p></p> back,
        // so we need to check for that as well as the content being null or undefined
        !loginPageContent || loginPageContent === "<p></p>"
          ? defaultContent
          : loginPageContent,
        {
          replace: sanitizeLinkHrefs,
        },
      )}
    </div>
  );
};
